// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.notification-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

/* Button & Badge */
.notification-btn {
    position: relative;
    background: none;
    border: none;
    color: #475569;
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
    transition: background-color 0.2s, color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.notification-btn:hover {
    background-color: #f1f5f9;
    color: #0f172a;
}

.badge {
    position: absolute;
    top: 4px;
    right: 4px;
    background-color: #ef4444;
    color: white;
    font-size: 0.7rem;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: 999px;
    border: 2px solid white;
}

/* Modal Core */
.notification-modal {
    position: absolute;
    top: 50px;
    right: 0;
    width: 320px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    border: 1px solid #e2e8f0;
    z-index: 1000;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    transition: width 0.3s ease;
}

.notification-modal.expanded {
    width: 400px;
}

/* Header */
.notif-header {
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8fafc;
}

.notif-header h4 {
    margin: 0;
    font-size: 1rem;
    color: #1e293b;
}

.notif-count {
    background: #dbeafe;
    color: #1d4ed8;
    font-size: 0.75rem;
    font-weight: 700;
    padding: 0.25rem 0.5rem;
    border-radius: 999px;
}

/* Body & List */
.notif-body {
    max-height: 350px;
    overflow-y: auto;
    padding: 0;
}

.notif-body.expanded-body {
    max-height: 500px;
}

.notif-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem 1rem;
    color: #94a3b8;
}

.empty-bell {
    color: #cbd5e1;
    margin-bottom: 0.5rem;
}

.notif-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.notif-item {
    display: flex;
    gap: 1rem;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #f1f5f9;
    transition: background-color 0.2s;
}

.notif-item:hover {
    background-color: #f8fafc;
}

.notif-item.unread {
    background-color: #f0fdf4;
}

/* Icons within List */
.notif-icon {
    display: flex;
    align-items: flex-start;
    padding-top: 0.25rem;
}

.text-emerald {
    color: #10b981;
}

.text-blue {
    color: #3b82f6;
}

.text-amber {
    color: #f59e0b;
}

.text-rose {
    color: #f43f5e;
}

.text-slate {
    color: #64748b;
}

/* Content Typography */
.notif-content {
    flex: 1 1;
}

.notif-title {
    margin: 0 0 0.25rem 0;
    font-size: 0.9rem;
    font-weight: 600;
    color: #1e293b;
}

.notif-desc {
    margin: 0 0 0.5rem 0;
    font-size: 0.85rem;
    color: #64748b;
    line-height: 1.4;
}

.notif-time {
    font-size: 0.75rem;
    color: #94a3b8;
}

/* Footers */
.notif-footer {
    padding: 1rem;
    text-align: center;
    background: #f8fafc;
    color: #2563eb;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    border-top: 1px solid #f1f5f9;
    transition: background-color 0.2s;
}

.notif-footer:hover {
    background: #f1f5f9;
}

.notif-pagination-footer {
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8fafc;
    border-top: 1px solid #f1f5f9;
}

.page-btn {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    background: white;
    border: 1px solid #cbd5e1;
    color: #475569;
    padding: 0.25rem 0.5rem;
    border-radius: 6px;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
    background: #f1f5f9;
    color: #0f172a;
}

.page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.page-info {
    font-size: 0.85rem;
    color: #64748b;
}

/* =========================================
   === INLINE ACTION BUTTONS ===
   ========================================= */

.notif-inline-actions {
    display: flex;
    gap: 0.5rem;
    margin-top: 0.75rem;
}

.inline-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    padding: 0.35rem 0.75rem;
    border-radius: 6px;
    font-size: 0.8rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid transparent;
}

.inline-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.approve-btn {
    background: #ecfdf5;
    color: #059669;
    border-color: #a7f3d0;
}

.approve-btn:hover:not(:disabled) {
    background: #d1fae5;
}

.reject-btn {
    background: #fef2f2;
    color: #dc2626;
    border-color: #fecaca;
}

.reject-btn:hover:not(:disabled) {
    background: #fee2e2;
}

.notif-action-success {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    margin-top: 0.5rem;
    color: #059669;
    font-size: 0.8rem;
    font-weight: 600;
}

/* =========================================
   === NOTIFICATION INFO MODAL ===
   ========================================= */

.notif-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.6);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    /* Highest priority to render over the navbar */
    padding: 1rem;
    animation: fadeInOverlay 0.2s ease-out;
}

.notif-modal-card {
    background: white;
    border-radius: 20px;
    padding: 2rem 2rem;
    max-width: 360px;
    width: 100%;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    animation: scaleIn 0.2s ease-out;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.notif-icon-wrapper {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.25rem;
}

.notif-modal-card h3 {
    margin: 0 0 0.75rem 0;
    font-size: 1.3rem;
    color: #1e293b;
    font-weight: 800;
}

.notif-modal-card p {
    margin: 0 0 1.5rem 0;
    color: #64748b;
    line-height: 1.5;
    font-size: 1rem;
}

.notif-btn-full {
    width: 100%;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 10px;
    font-weight: 700;
    font-size: 1rem;
    cursor: pointer;
    transition: background 0.2s;
}

.btn-success-fill {
    background: #10b981;
    color: white;
}

.btn-success-fill:hover {
    background: #059669;
}

.btn-danger-fill {
    background: #ef4444;
    color: white;
}

.btn-danger-fill:hover {
    background: #dc2626;
}

.bg-green-light {
    background: #ecfdf5;
}

.text-green {
    color: #059669;
}

.bg-red-light {
    background: #fef2f2;
}

.text-red {
    color: #dc2626;
}`, "",{"version":3,"sources":["webpack://./src/components/common/BellNotification.css"],"names":[],"mappings":"AAAA,cAAc;AACd;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,6CAA6C;IAC7C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA,WAAW;AACX;IACI,qBAAqB;IACrB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA,gBAAgB;AAChB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,uBAAuB;AACvB;IACI,SAAO;AACX;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;8CAE8C;;AAE9C;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;8CAE8C;;AAE9C;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,+CAA+C;IAC/C,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,qFAAqF;IACrF,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["/* Container */\n.notification-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n/* Button & Badge */\n.notification-btn {\n    position: relative;\n    background: none;\n    border: none;\n    color: #475569;\n    cursor: pointer;\n    padding: 8px;\n    border-radius: 50%;\n    transition: background-color 0.2s, color 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.notification-btn:hover {\n    background-color: #f1f5f9;\n    color: #0f172a;\n}\n\n.badge {\n    position: absolute;\n    top: 4px;\n    right: 4px;\n    background-color: #ef4444;\n    color: white;\n    font-size: 0.7rem;\n    font-weight: 700;\n    padding: 2px 6px;\n    border-radius: 999px;\n    border: 2px solid white;\n}\n\n/* Modal Core */\n.notification-modal {\n    position: absolute;\n    top: 50px;\n    right: 0;\n    width: 320px;\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n    border: 1px solid #e2e8f0;\n    z-index: 1000;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    transition: width 0.3s ease;\n}\n\n.notification-modal.expanded {\n    width: 400px;\n}\n\n/* Header */\n.notif-header {\n    padding: 1rem 1.25rem;\n    border-bottom: 1px solid #f1f5f9;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: #f8fafc;\n}\n\n.notif-header h4 {\n    margin: 0;\n    font-size: 1rem;\n    color: #1e293b;\n}\n\n.notif-count {\n    background: #dbeafe;\n    color: #1d4ed8;\n    font-size: 0.75rem;\n    font-weight: 700;\n    padding: 0.25rem 0.5rem;\n    border-radius: 999px;\n}\n\n/* Body & List */\n.notif-body {\n    max-height: 350px;\n    overflow-y: auto;\n    padding: 0;\n}\n\n.notif-body.expanded-body {\n    max-height: 500px;\n}\n\n.notif-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 3rem 1rem;\n    color: #94a3b8;\n}\n\n.empty-bell {\n    color: #cbd5e1;\n    margin-bottom: 0.5rem;\n}\n\n.notif-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.notif-item {\n    display: flex;\n    gap: 1rem;\n    padding: 1rem 1.25rem;\n    border-bottom: 1px solid #f1f5f9;\n    transition: background-color 0.2s;\n}\n\n.notif-item:hover {\n    background-color: #f8fafc;\n}\n\n.notif-item.unread {\n    background-color: #f0fdf4;\n}\n\n/* Icons within List */\n.notif-icon {\n    display: flex;\n    align-items: flex-start;\n    padding-top: 0.25rem;\n}\n\n.text-emerald {\n    color: #10b981;\n}\n\n.text-blue {\n    color: #3b82f6;\n}\n\n.text-amber {\n    color: #f59e0b;\n}\n\n.text-rose {\n    color: #f43f5e;\n}\n\n.text-slate {\n    color: #64748b;\n}\n\n/* Content Typography */\n.notif-content {\n    flex: 1;\n}\n\n.notif-title {\n    margin: 0 0 0.25rem 0;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #1e293b;\n}\n\n.notif-desc {\n    margin: 0 0 0.5rem 0;\n    font-size: 0.85rem;\n    color: #64748b;\n    line-height: 1.4;\n}\n\n.notif-time {\n    font-size: 0.75rem;\n    color: #94a3b8;\n}\n\n/* Footers */\n.notif-footer {\n    padding: 1rem;\n    text-align: center;\n    background: #f8fafc;\n    color: #2563eb;\n    font-size: 0.9rem;\n    font-weight: 600;\n    cursor: pointer;\n    border-top: 1px solid #f1f5f9;\n    transition: background-color 0.2s;\n}\n\n.notif-footer:hover {\n    background: #f1f5f9;\n}\n\n.notif-pagination-footer {\n    padding: 1rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: #f8fafc;\n    border-top: 1px solid #f1f5f9;\n}\n\n.page-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n    background: white;\n    border: 1px solid #cbd5e1;\n    color: #475569;\n    padding: 0.25rem 0.5rem;\n    border-radius: 6px;\n    font-size: 0.85rem;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.page-btn:hover:not(:disabled) {\n    background: #f1f5f9;\n    color: #0f172a;\n}\n\n.page-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.page-info {\n    font-size: 0.85rem;\n    color: #64748b;\n}\n\n/* =========================================\n   === INLINE ACTION BUTTONS ===\n   ========================================= */\n\n.notif-inline-actions {\n    display: flex;\n    gap: 0.5rem;\n    margin-top: 0.75rem;\n}\n\n.inline-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.25rem;\n    padding: 0.35rem 0.75rem;\n    border-radius: 6px;\n    font-size: 0.8rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: 1px solid transparent;\n}\n\n.inline-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.approve-btn {\n    background: #ecfdf5;\n    color: #059669;\n    border-color: #a7f3d0;\n}\n\n.approve-btn:hover:not(:disabled) {\n    background: #d1fae5;\n}\n\n.reject-btn {\n    background: #fef2f2;\n    color: #dc2626;\n    border-color: #fecaca;\n}\n\n.reject-btn:hover:not(:disabled) {\n    background: #fee2e2;\n}\n\n.notif-action-success {\n    display: flex;\n    align-items: center;\n    gap: 0.35rem;\n    margin-top: 0.5rem;\n    color: #059669;\n    font-size: 0.8rem;\n    font-weight: 600;\n}\n\n/* =========================================\n   === NOTIFICATION INFO MODAL ===\n   ========================================= */\n\n.notif-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(15, 23, 42, 0.6);\n    backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n    /* Highest priority to render over the navbar */\n    padding: 1rem;\n    animation: fadeInOverlay 0.2s ease-out;\n}\n\n.notif-modal-card {\n    background: white;\n    border-radius: 20px;\n    padding: 2rem 2rem;\n    max-width: 360px;\n    width: 100%;\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n    animation: scaleIn 0.2s ease-out;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.notif-icon-wrapper {\n    width: 64px;\n    height: 64px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1.25rem;\n}\n\n.notif-modal-card h3 {\n    margin: 0 0 0.75rem 0;\n    font-size: 1.3rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n.notif-modal-card p {\n    margin: 0 0 1.5rem 0;\n    color: #64748b;\n    line-height: 1.5;\n    font-size: 1rem;\n}\n\n.notif-btn-full {\n    width: 100%;\n    border: none;\n    padding: 0.75rem 1.5rem;\n    border-radius: 10px;\n    font-weight: 700;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.btn-success-fill {\n    background: #10b981;\n    color: white;\n}\n\n.btn-success-fill:hover {\n    background: #059669;\n}\n\n.btn-danger-fill {\n    background: #ef4444;\n    color: white;\n}\n\n.btn-danger-fill:hover {\n    background: #dc2626;\n}\n\n.bg-green-light {\n    background: #ecfdf5;\n}\n\n.text-green {\n    color: #059669;\n}\n\n.bg-red-light {\n    background: #fef2f2;\n}\n\n.text-red {\n    color: #dc2626;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
